module.exports = __webpack_public_path__ + "static/img/lunbo4.f7943013.webp";